export default "__VITE_ASSET__D$mOJGTb__"